// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8cb39710","967":"7375ab5a"}[chunkId] + ".chunk.js";
};